import Vue from 'vue';
import Vuex from 'vuex';
import { firebasedb, firestoredb, firebaseStorage, firebaseAuth } from '.././firebase';
import axios from 'axios';
import { stat } from 'fs';

Vue.use(Vuex);
Vue.use(firebaseAuth);
Vue.use(firebasedb);
Vue.use(firestoredb);
Vue.use(firebaseStorage);

export const store = new Vuex.Store({
  state: {
    _isTrue: true,
    isBusy: false,
    posts: [],
    roles: [],
    resentPosts: [],
    file: null,
    isApp:false,
    resentPostFilteredByIQ: []
  },
  getters: {
    isTrue(state) {
      return state._isTrue;
    },
    isBusy(state) {
      return state.isBusy;
    },
    posts(state) {
      return state.posts;
    },
    roles(state) {
      return state.roles;
    },
    resentPosts(state) {
      return state.resentPosts;
    },
    isApp(state) {
      return state.isApp;
    },
    resentPostFilteredByIQ(state){
      return state.resentPostFilteredByIQ;
    }
  },
  mutations: {
    toggle: function(state, payload) {
      return (state._isTrue = payload);
    },
    setIsBusy: function(state, payload) {
      return (state.isBusy = payload);
    },
    set_comments: (state, payload) => {
      state.posts = payload;
    },
    storeRoles(state, payload) {
      state.roles = payload.roles;
    },
    setRecentPosts(state, payload) {
      state.resentPosts = payload;
    },
    setIsApp(state, payload){
      state.isApp = payload;
    },
    set_LastSevenDaysFilteredByIQ(state, payload) {
      state.resentPostFilteredByIQ = payload;
    }
  },
  actions: {
    toggle: function(context) {
      let temp = !context.state._isTrue;
      firebasedb.ref('settings/setting').set(temp);
    },
    getFirebaseData: function(context) {
      firebasedb.ref('settings/setting').on('value', function(snapshot) {
        context.commit('toggle', snapshot.val());
      });
    },
    togglefs: function(context) {
      firestoredb
        .collection('settings')
        .doc('setting')
        .set({
          setting: true
        });
    },
    load_comments: function({ commit }, payload) {
      //getlastsevendayscounts
      //https://wt-bc97630911ec8a9b6ec9c96cf4c401e6-0.run.webtask.io/express-with-mongo-db
      axios
        .post(
          `https://wt-bc97630911ec8a9b6ec9c96cf4c401e6-0.sandbox.auth0-extend.com/express-with-mongo-db/getlastsevendayscounts`,
          payload
        )
        .then(
          response => {
            commit('setIsBusy', false);
            commit('set_comments', response.data);
          },
          err => {
            console.log(err);
            commit('setIsBusy', false);
          }
        );
    },
    authFirebase({commit}) {      
      const token = localStorage.getItem('access_token');
      let config = {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }
      if (token) {
        axios
          .get(`https://us-central1-fir-vue-de1f1.cloudfunctions.net/customToken`, config)
          .then(respons => {
            firebaseAuth.signInWithCustomToken(respons.data)
            //.then(r => {console.log(r);})
            //console.log(respons.data);
          },
        err => {console.log(err)});
        
      }
    },
    storeRoles({ commit }, payload) {
      commit('storeRoles', payload);
    },
    getResentPosts({ commit }, payload) {
      //get last 10 posts
      axios
        .get(
          `https://wt-bc97630911ec8a9b6ec9c96cf4c401e6-0.sandbox.auth0-extend.com/express-with-mongo-db/`
        )
        .then(
          response => {
            const regex = /\S+@\S+\.\S+/;
            response.data.forEach((item, i) => {
              item.body = item.body.replace(new RegExp(regex, 'g'), '*****');
              response.data[i] = item;
            });
            commit('setRecentPosts', response.data);
          },
          err => {
            console.log(err);
          }
        );
    },
    loadLastSevenDaysFilteredByIQ({commit}, payload){
      axios
        .post(
          `https://wt-bc97630911ec8a9b6ec9c96cf4c401e6-0.sandbox.auth0-extend.com/express-with-mongo-db/getlastsevendaysfiltered`,
          payload
        )
        .then(
          response => {
            const regex = /\S+@\S+\.\S+/;
            response.data.forEach((item, i) => {
              item.body = item.body.replace(new RegExp(regex, 'g'), '*****');
              response.data[i] = item;
            });
            commit('setIsBusy', false);
            commit('set_LastSevenDaysFilteredByIQ', response.data);
          },
          err => {
            console.log(err);
            commit('setIsBusy', false);
          }
        );
    },
    setIsApp({ commit }, payload){
      commit('setIsApp',payload);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js